//----- Dependancies -----
// https://www.npmjs.com/package/youtube-player
// https://developers.google.com/youtube/iframe_api_reference
// https://developers.google.com/youtube/player_parameters
import YouTubePlayer from 'youtube-player';


var instances = {};

function initialise(context) {
    return new Promise((resolve, reject) => {
        let id = generateId();
        // Assign id.
        context.attr('youtube-video-id', id);
        // Assign class.
        context.addClass('youtube-video-frame');

        let url  = context.attr(expressSelectors()['axis-youtube-player']['url']);
        if (!url) {
            url = context.attr(expressSelectors()['axis-video-player']['url']);
            if (!url) {
                console.error("No url found", context);
                return false;
            }
        }
        // Get the video start position.
        let startPos = context.attr(expressSelectors()['axis-youtube-player']['start-position']);
        // Fallback.
        if (!startPos) {
            startPos = 0;
        }
        // Get the video end position.
        let endPos = context.attr(expressSelectors()['axis-youtube-player']['end-position']);
        // Fallback.
        if (!endPos) {
            endPos = undefined;
        }
        let config = { 
            mediaContentUrl: url,
            'startSeconds': startPos, 
            'endSeconds': endPos
        };
        // Initialise player.
        let player = YouTubePlayer(context[0]);
        // Cue the video.
        player.cueVideoByUrl(config);

        instances[id] = {};
        instances[id]['player-object'] = player;
        instances[id]['video-url'] = url;
        instances[id]['start-pos'] = startPos;
        instances[id]['end-pos'] = endPos;

        player.addEventListener('onStateChange', function(event) {
            instances[id]['state'] = event.data;
            // Resolve once qued.
            if (event.data == "5") {
                resolve(player);
            }
        });
        //return player;
    });
}

function playVideo(id) {
    let player = getPlayer(id);
    let playerStatus = getState(id);

    return player.playVideo();
} 

function pauseVideo(id) {
    let player = getPlayer(id);
    return player.pauseVideo();
}

function stopVideo(id) {
    let player = getPlayer(id);
    return player.stopVideo();
}

function getState(id) {
    // let state = $('body .youtube-video-frame[youtube-video-id=' + id + ']').attr('data-video-state');
    return instances[id]['state'];
}

function getDuration(id) {
    let player = getPlayer(id);
    let duration = player.getDuration();
    return duration;
}

// ----- Get configuration(s) ----- 

// Get the player object.
function getPlayer(id) {
    if (!id) {
        AXISDebug.output(3,"No Id provided cannot get player object.");
        return false;
    }
    return instances[id]['player-object'];
}

function getInstanceId(context) {
    let instanceId = context.attr('youtube-video-id');
    
    if (!instanceId) {
        AXISDebug.output(3,"Instance Id has not been defined, has this video been initialised?");
        return false;
    }

    return instanceId;
}

function destroy(id) {
   let player = getPlayer(id);
   player.destroy();
   delete instances[id];
   return true;
}

var component = $.component = {
    initialise: (context) => {
        return initialise(context);
    },
    initialiseByUrl: (url) => {
        return initialiseByUrl(url);
    },
    playVideo: (context) => {
        let instanceId = getInstanceId(context);
        return playVideo(instanceId);
    },
    pauseVideo: (context) => {
        let instanceId = getInstanceId(context);
        return pauseVideo(instanceId);
    },
    stopVideo: (context) => {
        let instanceId = getInstanceId(context);
        return stopVideo(instanceId);
    },
    getState: (context) => {
        let instanceId = getInstanceId(context)
        return getState(instanceId);
    },
    getDuration: (context) => {
        let instanceId = getInstanceId(context);
        return getDuration(instanceId);
    },
    destroy: (context) => {
        let instanceId = getInstanceId(context);
        return destroy(instanceId);
    }
}
 
export { component };
